// extracted by css-extract-rspack-plugin
export default {"row-recovered":"row-recovered-jHsh9o","rowRecovered":"row-recovered-jHsh9o","table":"table-CtLIa6"};